import { Injectable } from '@angular/core';
// import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { LogService, IAuthenticationService, PershingError, ServiceRouter } from '@pershing/pershing-core';
import { Agreement } from './../models/agreement.model';
import { AgreementResponse } from './../models/agreement-response.model';
import { EdeliveryServiceDefinition } from './../models/router-service-definition';
import { HttpHeaders } from '@angular/common/http';

let headers = new HttpHeaders({
    'Content-Type': 'application/json'
});

/**
 * @desc interacts with the backend services to fetch the data and updates the data.
 */
@Injectable()
export class AgreementService {
    private baseUrl = '';
    agreementResponse$: Observable<AgreementResponse>;
    error$: Observable<PershingError>;
    private _agreementResponse: Subject<AgreementResponse>;
    private _error: Subject<PershingError>;
    private dataStore: {
        agreementResponse: AgreementResponse;
    };
    enableBackToEnrollment: boolean = false;
    updateAgreementInProgressFlag: boolean = false;
    remindMeLaterInProgressFlag: boolean = false;

    constructor(private logService: LogService, private http: HttpClient, private authenticationService: IAuthenticationService, private serviceRouter: ServiceRouter) {
        this._error = new BehaviorSubject<PershingError>(null);
        this.error$ = this._error.asObservable();
        this._agreementResponse = <Subject<AgreementResponse>>new Subject();
        this.agreementResponse$ = this._agreementResponse.asObservable();
        this.dataStore = { agreementResponse: null };
        this.baseUrl = this.serviceRouter.getServiceRouteURL( EdeliveryServiceDefinition.getInstance(), { ignoreOptions: { serviceVersion: true } } );
        // this.baseUrl = 'http://localhost:8080/edc/edelivery';
    }
    retrieveAgreement(): void {
        let url: string = this.baseUrl + '/retrieveAgreement';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/retrieveAgreement/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/retrieveAgreement/3CR/MOHBCBC';
        console.log('retrieving agreement ');
        if (this.authenticationService.isLoggedIn()) {
            this.http.get(`${url}`, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('retrieve agreement success: ', data.errorCode);
                        this.logService.info('retrieve agreement success: ', data);
                        this.clearError();
                        let agreementResponse: AgreementResponse = new AgreementResponse();
                        agreementResponse.response = data.response;
                        this.dataStore.agreementResponse = agreementResponse;
                        this._agreementResponse.next(Object.assign({}, this.dataStore).agreementResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                },
                    error => {
                        this.setError(error);
                    });
        } else {
            console.log('User not logged in');
        }
    }

    updateAgreement(agreement: Agreement): void {
        if (!this.updateAgreementInProgressFlag) {
            this.updateAgreementInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/updateAgreement';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/updateAgreement/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/updateAgreement/3CR/MOHBCBC';
        // let id = 'ANNAHQA';
        // let ibd = 'HQA';
        let body = agreement;
        console.log('update agreement body: ', body);
        if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, body, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('update agreement success: ', data.errorCode);
                        this.logService.info('update agreement success success: ', data);
                        this.clearError();
                        console.log('update agreement response', data);
                        let agreementResponse: AgreementResponse = new AgreementResponse();
                        agreementResponse.response = data.response;
                        this.dataStore.agreementResponse = agreementResponse;
                        this._agreementResponse.next(Object.assign({}, this.dataStore).agreementResponse);
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.updateAgreementInProgressFlag = false;
                },
                    error => {
                        this.updateAgreementInProgressFlag = false;
                        this.setError(error);
                    });
        } else {
            console.log('User not logged in');
        }
    }

    remindMeLaterAgreement(): void {
        if (!this.remindMeLaterInProgressFlag) {
            this.remindMeLaterInProgressFlag = true;
        } else {
            return;
        }
        let url: string = this.baseUrl + '/remindMeLater';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/retrieveAgreement/3CR/EDTEST';
        // let url: string = this.baseUrl + 'https://nonprod14-cluster.bnymellon.net/dev-edc-edelivery-service-service/edc/edelivery/retrieveAgreement/3CR/MOHBCBC';
        console.log('remindMeLater agreement ');
        if (this.authenticationService.isLoggedIn()) {
            this.http.post(`${url}`, { headers: headers })
                .subscribe((data: any) => {
                    if (data.errorCode === 0 || data.errorCode === 90) { // success
                        this.logService.info('remindMeLater agreement success: ', data.errorCode);
                        this.logService.info('remindMeLater agreement success: ', data);
                        this.clearError();
                    } else { // error code from backend
                        this.logService.error('getEdelPreferences() errorCode: ', data.errorCode);
                        this.setError('Failed to retrieve data', data.errorCode);
                    }
                    this.remindMeLaterInProgressFlag = false;
                },
                    error => {
                        this.remindMeLaterInProgressFlag = false;
                        this.setError(error);
                    });
        } else {
            console.log('User not logged in');
        }
    }

    setError(errorMessage: string, errorCode?: string): void {
        this._error.next(new PershingError(errorMessage, 'AgreementService', errorCode));
    }

    clearError(): void {
        this._error.next(null);
    }
}
